import { LogOut } from 'lucide-react';
import { Link } from 'react-router-dom';
import { providerIdLabel } from '@/features/auth';
import { useSessionSignOut } from '@/hooks/use-session-sign-out';
import { useSessionStore } from '@/store/session-store';

/**
 * Session indicator and logout control (US-003 AC-002/AC-003, US-004 AC-004). Rendered by the shell, so
 * it is present on every authenticated screen.
 *
 * Contact and FAQ open without a session, so the anonymous case is not empty: it offers the way in,
 * which is otherwise unreachable from those screens.
 */
export function SessionControls(): React.JSX.Element {
  const providerId = useSessionStore((state) => state.providerId);
  const idMatchType = useSessionStore((state) => state.idMatchType);
  const signOut = useSessionSignOut();

  if (providerId === null) {
    return (
      <Link
        to="/login"
        className="text-brand-600 hover:text-gold-800 text-[13px] font-semibold transition-colors"
      >
        Sign in
      </Link>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <p className="border-gold-200 bg-gold-50 text-gold-800 rounded-full border px-3 py-1 text-xs">
        {providerIdLabel(providerId, idMatchType)}: {providerId}
      </p>

      <button
        type="button"
        onClick={(): void => {
          signOut();
        }}
        className="text-muted hover:text-gold-800 inline-flex items-center gap-2 rounded-md px-2 py-2 text-[13px] font-semibold transition-colors"
      >
        <LogOut aria-hidden="true" className="h-3.5 w-3.5" />
        Logout
      </button>
    </div>
  );
}
